import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Input, Label, Checkbox } from '../input/Input';
import { Button } from '../button/Button';


export function RegisterForm({ onSubmit }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

 const handleSubmit = (e) => {
  e.preventDefault();


  if(password !== confirmPassword){

    alert("As senhas não conferem");

    return;

  }


  onSubmit?.({
    nome: name,
    email: email,
    senha: password
  });

};


  return (
    <div className="w-full max-w-[400px] bg-white border border-border p-8 rounded-card shadow-md font-body space-y-6">

      {/* Brand Header */}
      <div className="text-center">
        <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center text-white font-display font-semibold text-2xl mx-auto mb-3">
          S
        </div>

        <h2 className="font-display text-h3 font-bold text-text-primary">
          Criar conta
        </h2>

        <p className="text-caption text-text-secondary mt-1">
          Comece a organizar seu negócio com o SON.
        </p>
      </div>


      <form onSubmit={handleSubmit} className="space-y-4">


        <div>
          <Label htmlFor="name" required>
            Nome
          </Label>

          <Input
            id="name"
            type="text"
            placeholder="Seu nome"
            required
            value={name}
            onChange={(e)=>setName(e.target.value)}
          />
        </div>



        <div>
          <Label htmlFor="email" required>
            Email
          </Label>

          <Input
            id="email"
            type="email"
            placeholder="nome@empresa.com"
            required
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
          />
        </div>



        <div>
          <Label htmlFor="password" required>
            Senha
          </Label>

          <Input
            id="password"
            type="password"
            placeholder="••••••••"
            required
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
          />
        </div>



        <div>
          <Label htmlFor="confirmPassword" required>
            Confirmar senha
          </Label>

          <Input
            id="confirmPassword"
            type="password"
            placeholder="••••••••"
            required
            value={confirmPassword}
            onChange={(e)=>setConfirmPassword(e.target.value)}
          />
        </div>



        <Button type="submit" className="w-full mt-2">
          Criar minha conta
        </Button>


      </form>


      <p className="text-center text-caption text-text-secondary">
        Já possui uma conta?

        <Link
    to="/login"
    className="ml-1 text-primary font-semibold hover:underline"
  >
    Entrar
  </Link>

      </p>

    </div>
  );
}